export const TrafikenConfig = {
    infoLayerServiceBaseUrl: '',
    imagesBaseUrl: '/images/',
    templatesBaseUrl: '/static/handlebars',
    vasttrafikTokenUrl: '/api/vasttrafik/action/gettoken/',
    trafficMessages: {
        region: 'gbg',
        url: '/api/trafficmessages/action/getnearby/',
        distance: 25,
    },
    gbgParkings: {
        authKey: '84e5851f-14d2-4a8f-b171-5754613d40a4',
        serviceUrl: '//data.goteborg.se/ParkingService/v2.1/',
    },
    gbgOpenApi: {
        authKey: '84e5851f-14d2-4a8f-b171-5754613d40a4',
        baseUrl: '//data.goteborg.se',
    },
    styrOchStall: {
        serviceUrl: '//data.goteborg.se/SelfServiceBicycleService/v1.0/Stations/',
        radius: 250,
    },
};
